/* Beauté by Sirina — theme behaviour. No dependencies. */
(function () {
  'use strict';

  var money = function (cents) {
    var pounds = cents / 100;
    return '£' + (pounds % 1 === 0 ? pounds.toFixed(0) : pounds.toFixed(2));
  };
  var routes = window.bbsRoutes || { cart_add_url: '/cart/add', cart_url: '/cart' };

  /* Mobile menu */
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    var menu = document.getElementById(btn.getAttribute('aria-controls'));
    if (!menu) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (open) { menu.removeAttribute('open'); } else { menu.setAttribute('open', ''); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') { btn.click(); btn.focus(); }
    });
  });

  /* Postcode check: "Do I come to you?" */
  function normalisePostcode(v) { return (v || '').toUpperCase().replace(/\s+/g, ''); }
  function postcodeAllowed(value, list) {
    var pc = normalisePostcode(value);
    if (!pc) return null;
    var areas = (list || '').split(',').map(function (s) { return s.trim().toUpperCase(); }).filter(Boolean);
    if (!areas.length) return true;
    var outward = pc.length > 3 ? pc.slice(0, -3) : pc, inward = pc.length > 3 ? pc.slice(-3) : '';
    return areas.some(function (a) {
      var parts = a.split(/\s+/);
      if (parts[0] !== outward) return false;
      return parts.length < 2 || inward.indexOf(parts[1]) === 0;
    });
  }
  /* Distance check: looks the postcode up on postcodes.io (free, open data) and measures from the studio.
     Resolves { ok, miles } or { invalid: true }; falls back to the back-up postcode list if the lookup fails. */
  var pcCache = {};
  function milesBetween(a, b) {
    var r = Math.PI / 180, dLat = (b[0] - a[0]) * r, dLon = (b[1] - a[1]) * r;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a[0] * r) * Math.cos(b[0] * r) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return 3958.8 * 2 * Math.asin(Math.sqrt(h));
  }
  function checkDistance(value, opts) {
    var pc = normalisePostcode(value);
    var lat = parseFloat(opts.lat), lng = parseFloat(opts.lng), radius = parseFloat(opts.radius) || 5;
    var fallback = function () { var ok = postcodeAllowed(value, opts.postcodes); return { ok: ok !== false, fallback: true }; };
    if (!pc) return Promise.resolve(null);
    if (isNaN(lat) || isNaN(lng)) return Promise.resolve(fallback());
    if (pcCache[pc]) return Promise.resolve(pcCache[pc]);
    return fetch('https://api.postcodes.io/postcodes/' + encodeURIComponent(pc))
      .then(function (r) {
        if (r.status === 404) return { invalid: true };
        if (!r.ok) throw new Error('lookup failed');
        return r.json().then(function (j) {
          var miles = milesBetween([lat, lng], [j.result.latitude, j.result.longitude]);
          return { ok: miles <= radius, miles: miles };
        });
      })
      .then(function (res) { pcCache[pc] = res; return res; })
      .catch(fallback);
  }

  document.querySelectorAll('[data-postcode-check]').forEach(function (form) {
    var input = form.querySelector('input');
    var out = form.parentElement.querySelector('[data-postcode-result]');
    var list = form.getAttribute('data-postcodes');
    var btn = form.querySelector('[data-postcode-btn]');
    var ukPostcode = /^[A-Z]{1,2}[0-9][A-Z0-9]?\s*[0-9][A-Z]{2}$/i;
    input.addEventListener('input', function () {
      var valid = ukPostcode.test(input.value.trim());
      if (btn) btn.disabled = !valid;
      form.classList.toggle('bbs-is-valid', valid);
      if (out) { out.textContent = ''; }
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn && btn.disabled) return;
      if (!out) return;
      out.className = 'bbs-postcode__result'; out.textContent = 'Checking…';
      checkDistance(input.value, { lat: form.getAttribute('data-lat'), lng: form.getAttribute('data-lng'), radius: form.getAttribute('data-radius'), postcodes: list })
        .then(function (res) {
          if (!res) { out.textContent = 'Pop your postcode in first.'; out.className = 'bbs-postcode__result bbs-form-error'; return; }
          if (res.invalid) { out.textContent = "I couldn't find that postcode. Please check it."; out.className = 'bbs-postcode__result bbs-form-error'; return; }
          out.className = 'bbs-postcode__result ' + (res.ok ? 'bbs-form-success' : 'bbs-form-error');
          out.textContent = res.ok ? form.getAttribute('data-yes') : form.getAttribute('data-no');
        });
    });
  });

  /* Treatment quiz */
  document.querySelectorAll('[data-quiz]').forEach(function (quiz) {
    var steps = quiz.querySelectorAll('[data-quiz-step]');
    var answers = [];
    var stepLabel = quiz.querySelector('[data-quiz-count]');
    function show(i) {
      steps.forEach(function (s, n) { s.hidden = n !== i; });
      if (stepLabel) stepLabel.textContent = i < steps.length - 1 ? 'QUESTION ' + (i + 1) + ' OF ' + (steps.length - 1) : 'MY SUGGESTION';
    }
    quiz.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-quiz-answer]');
      if (!opt) return;
      answers.push(opt.getAttribute('data-quiz-answer'));
      var current = Array.prototype.indexOf.call(steps, opt.closest('[data-quiz-step]'));
      if (current + 1 < steps.length - 1) { show(current + 1); return; }
      var focus = answers[0] || 'nails';
      quiz.querySelectorAll('[data-quiz-result]').forEach(function (r) { r.hidden = r.getAttribute('data-quiz-result') !== focus; });
      show(steps.length - 1);
      var res = quiz.querySelector('[data-quiz-result]:not([hidden]) a');
      if (res) res.focus();
    });
    var restart = quiz.querySelector('[data-quiz-restart]');
    if (restart) restart.addEventListener('click', function () { answers = []; show(0); });
    show(0);
  });

  /* Basket helpers */
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.');
        return j;
      });
    });
  }
  function refreshCount() {
    return fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
        document.querySelectorAll('cart-icon').forEach(function (el) { if (typeof el.renderCartBubble === 'function') el.renderCartBubble(n); });
        document.querySelectorAll('[data-cart-link]').forEach(function (el) { el.setAttribute('aria-label', 'Basket, ' + n + ' item' + (n === 1 ? '' : 's')); });
        document.querySelectorAll('[data-basket-bar]').forEach(function (bar) {
          var t = bar.querySelector('[data-basket-bar-text]');
          if (t) t.textContent = n + (n === 1 ? ' item' : ' items') + ' · ' + money(cart.total_price);
          bar.hidden = n === 0;
          var other = document.querySelector('[data-book-bar]');
          if (other) other.hidden = n > 0;
        });
        return cart;
      })
      .catch(function () {});
  }
  function addItems(items) {
    return postJSON(routes.cart_add_url + '.js', { items: items }).then(function (res) { refreshCount(); return res; });
  }

  /* Treatment page: add to basket */
  document.querySelectorAll('[data-add-form]').forEach(function (form) {
    var idInput = form.querySelector('[name="id"]');
    var priceEl = form.querySelector('[data-add-price]');
    var button = form.querySelector('[data-add-button]');
    var errorBox = form.querySelector('[data-add-error]');
    var added = form.querySelector('[data-added]');
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-variant-radio]')) {
        idInput.value = e.target.value;
        if (priceEl) priceEl.textContent = e.target.getAttribute('data-price');
      }
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errorBox.hidden = true;
      var props = {};
      new FormData(form).forEach(function (v, k) {
        var m = k.match(/^properties\[(.+)\]$/);
        if (m && String(v).trim() !== '') props[m[1]] = v;
      });
      var original = button.textContent;
      button.setAttribute('aria-disabled', 'true');
      button.textContent = 'Adding…';
      addItems([{ id: parseInt(idInput.value, 10), quantity: 1, properties: props }])
        .then(function () {
          button.hidden = true;
          if (added) { added.hidden = false; added.focus(); }
        })
        .catch(function (err) { errorBox.textContent = err.message; errorBox.hidden = false; })
        .then(function () { button.removeAttribute('aria-disabled'); button.textContent = original; });
    });
  });

  /* One of each treatment: show "Added" for anything already in the basket */
  function setQuickAdded(form) {
    var btn = form.querySelector('button');
    var label = form.querySelector('[data-quick-label]');
    if (!btn || !label) return;
    label.textContent = 'Added ✓';
    btn.classList.add('bbs-is-added');
    btn.setAttribute('aria-disabled', 'true');
    btn.setAttribute('aria-label', (btn.getAttribute('aria-label') || '').replace(/^Add /, 'Added ') || 'Added to basket');
  }
  function markInBasket(cart) {
    if (!cart || !cart.items) return;
    var ids = cart.items.map(function (i) { return String(i.variant_id); });
    document.querySelectorAll('[data-quick-add]').forEach(function (form) {
      var input = form.querySelector('[name="id"]');
      if (input && ids.indexOf(String(input.value)) > -1) setQuickAdded(form);
    });
    document.querySelectorAll('[data-add-form]').forEach(function (form) {
      if (form.hasAttribute('data-voucher')) return;
      var input = form.querySelector('[name="id"]');
      var button = form.querySelector('[data-add-button]');
      var added = form.querySelector('[data-added]');
      if (input && button && added && ids.indexOf(String(input.value)) > -1) { button.hidden = true; added.hidden = false; }
    });
  }
  refreshCount().then(markInBasket);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount().then(markInBasket); });

  /* Treatment lists: quick add */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quick-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    var label = form.querySelector('[data-quick-label]');
    if (btn.getAttribute('aria-disabled') === 'true') return;
    btn.setAttribute('aria-disabled', 'true');
    label.textContent = 'Adding…';
    addItems([{ id: parseInt(form.querySelector('[name="id"]').value, 10), quantity: 1 }])
      .then(function () { setQuickAdded(form); })
      .catch(function (err) { label.textContent = 'Try again'; btn.removeAttribute('aria-disabled'); console.warn(err.message); });
  });

  /* Empty basket left with only a travel fee: tidy it away */
  document.querySelectorAll('[data-clear-travel]').forEach(function (el) {
    postJSON('/cart/change.js', { id: el.getAttribute('data-clear-travel'), quantity: 0 }).then(refreshCount).catch(function () {});
  });

  /* Basket page after an unfinished "pay in person" checkout: swap the deposit back for the treatments */
  document.querySelectorAll('[data-restore-basket]').forEach(function (el) {
    var depositKey = el.getAttribute('data-restore-basket');
    fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = [];
        try { items = JSON.parse((cart.attributes && cart.attributes._basket) || '[]'); } catch (e) { items = []; }
        return postJSON('/cart/change.js', { id: depositKey, quantity: 0 })
          .then(function () { return items.length ? postJSON(routes.cart_add_url + '.js', { items: items }) : null; })
          .then(function () { return postJSON('/cart/update.js', { attributes: { '_basket': '', 'Payment': '', 'Balance due on the day': '', 'Treatments': '', 'Booking total': '' } }); });
      })
      .then(function () { window.location.reload(); })
      .catch(function () {});
  });

  /* Basket page: where, when, then payment */
  document.querySelectorAll('[data-checkout]').forEach(function (form) {
    var cfg = JSON.parse(form.querySelector('[data-checkout-config]').textContent);
    var daysWrap = form.querySelector('[data-days]');
    var dateFallback = form.querySelector('[data-date-fallback]');
    var homeFields = form.querySelector('[data-home-fields]');
    var studioNote = form.querySelector('[data-studio-note]');
    var pcInput = form.querySelector('[name="attributes[Postcode]"]');
    var addrInput = form.querySelector('[name="attributes[Address]"]');
    var pcResult = form.querySelector('[data-postcode-result]');
    var errorBox = form.querySelector('[data-checkout-error]');
    var button = form.querySelector('[data-checkout-button]');
    var travelRow = form.querySelector('[data-sum-travel-row]');
    var sumTotal = form.querySelector('[data-sum-total]');
    var sumWhere = form.querySelector('[data-sum-where]');
    var sumWhen = form.querySelector('[data-sum-when]');

    var dows = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var longDows = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    var closed = (cfg.closed || '').split(',').map(function (x) { return x.trim().slice(0, 3).toLowerCase(); }).filter(Boolean);
    var blocked = Array.isArray(cfg.blocked) ? cfg.blocked : [];
    var slotLen = cfg.slotMinutes || 60;
    var visitLen = Math.max(cfg.minutes || 0, 1);
    var slotInputs = Array.prototype.slice.call(form.querySelectorAll('[name="attributes[Time]"]'));
    function iso(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
    function toMins(t) {
      var m = String(t).trim().toLowerCase().match(/^(\d{1,2})[:.](\d{2})\s*(am|pm)?$/);
      if (!m) return null;
      var h = parseInt(m[1], 10), mi = parseInt(m[2], 10);
      if (m[3] === 'pm' && h < 12) h += 12;
      if (m[3] === 'am' && h === 12) h = 0;
      return h * 60 + mi;
    }
    function blocksFor(dayIso) { return blocked.filter(function (b) { return b.from <= dayIso && dayIso <= (b.to || b.from); }); }
    function takenMins(dayIso) {
      var out = [];
      blocksFor(dayIso).forEach(function (b) { (b.times || []).forEach(function (t) { var m = toMins(t); if (m !== null) out.push(m); }); });
      return out;
    }
    function wholeDayBlocked(dayIso) { return blocksFor(dayIso).some(function (b) { return b.whole; }); }
    function slotFree(dayIso, startMins) {
      var end = startMins + visitLen;
      return !takenMins(dayIso).some(function (t) { return t < end && t + slotLen > startMins; });
    }
    function freeSlotsOn(dayIso) { return slotInputs.filter(function (inp) { var m = toMins(inp.value); return m !== null && slotFree(dayIso, m); }).length; }

    var cursor = new Date(); cursor.setHours(12, 0, 0, 0); cursor.setDate(cursor.getDate() + (cfg.lead || 0));
    var lastDay = new Date(); lastDay.setHours(12, 0, 0, 0);
    if (cfg.maxMonths) lastDay.setMonth(lastDay.getMonth() + cfg.maxMonths); else lastDay.setFullYear(lastDay.getFullYear() + 5);
    var moreBtn = null;
    function addDays(count) {
      var made = 0, guard = 0;
      while (made < count && guard < 400) {
        guard++;
        if (cursor > lastDay) { if (moreBtn) moreBtn.hidden = true; break; }
        var d = new Date(cursor.getTime());
        cursor.setDate(cursor.getDate() + 1);
        var dow = dows[d.getDay()];
        if (closed.indexOf(dow.toLowerCase()) !== -1) continue;
        var dayIso = iso(d);
        var nice = longDows[d.getDay()] + ' ' + d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
        var full = wholeDayBlocked(dayIso) || freeSlotsOn(dayIso) === 0;
        var label = document.createElement('label');
        label.className = 'bbs-day' + (full ? ' bbs-day--full' : '');
        label.innerHTML = '<input type="radio" name="attributes[Date]"><span class="bbs-day__dow"></span><span class="bbs-day__num"></span><span class="bbs-day__month"></span>';
        var input = label.querySelector('input');
        input.value = nice;
        input.setAttribute('data-iso', dayIso);
        if (full) input.disabled = true;
        else if (cfg.savedDate === nice) input.checked = true;
        label.querySelector('.bbs-day__dow').textContent = dow;
        label.querySelector('.bbs-day__num').textContent = d.getDate();
        label.querySelector('.bbs-day__month').textContent = full ? cfg.msgFull : months[d.getMonth()].slice(0, 3);
        label.setAttribute('aria-label', nice + (full ? ', ' + cfg.msgFull : ''));
        daysWrap.insertBefore(label, moreBtn);
        made++;
      }
    }
    if (daysWrap) {
      moreBtn = document.createElement('button');
      moreBtn.type = 'button';
      moreBtn.className = 'bbs-day bbs-day--more';
      moreBtn.innerHTML = '<span class="bbs-day__dow">More</span><span class="bbs-day__num" aria-hidden="true">→</span><span class="bbs-day__month">dates</span>';
      moreBtn.setAttribute('aria-label', 'Show more dates');
      daysWrap.appendChild(moreBtn);
      addDays(6);
      if (cursor > lastDay) moreBtn.hidden = true;
      moreBtn.addEventListener('click', function () { addDays(6); if (cursor > lastDay) moreBtn.hidden = true; });
      if (dateFallback) dateFallback.remove();
    }
    function refreshSlots() {
      var dayInput = form.querySelector('[name="attributes[Date]"]:checked');
      var dayIso = dayInput ? dayInput.getAttribute('data-iso') : null;
      slotInputs.forEach(function (inp) {
        var m = toMins(inp.value);
        var free = !dayIso || (m !== null && slotFree(dayIso, m));
        inp.disabled = !free;
        inp.parentElement.classList.toggle('bbs-slot--taken', !free);
        if (!free && inp.checked) inp.checked = false;
      });
    }

    function payDeposit() {
      var r = form.querySelector('[name="bbs-pay"]:checked');
      return !!(cfg.depositAvailable && cfg.depositVariant && r && r.value === 'deposit');
    }
    function isHome() {
      var r = form.querySelector('[name="attributes[Location]"]:checked');
      return !!r && r.getAttribute('data-kind') === 'home';
    }
    function chosen(name) {
      var r = form.querySelector('[name="attributes[' + name + ']"]:checked') || form.querySelector('input[type="date"][name="attributes[' + name + ']"]');
      return r && r.value ? r.value : '';
    }
    function update() {
      var home = isHome();
      var travel = home && cfg.travelVariant ? cfg.travelPrice : 0;
      if (homeFields) homeFields.hidden = !home;
      if (studioNote) studioNote.hidden = home;
      if (travelRow) travelRow.hidden = !travel;
      if (sumTotal) sumTotal.textContent = money(cfg.subtotal + travel);
      var dep = payDeposit();
      form.querySelectorAll('[data-sum-deposit-row]').forEach(function (r) { r.hidden = !dep; });
      var bal = form.querySelector('[data-sum-balance]');
      if (bal) bal.textContent = money(Math.max(cfg.subtotal + travel - cfg.depositPrice, 0));
      button.textContent = dep ? 'Pay ' + money(cfg.depositPrice) + ' deposit' : original;
      if (sumWhere) sumWhere.textContent = home ? 'At your home' + (pcInput && pcInput.value ? ', ' + pcInput.value.toUpperCase() : '') : 'My home studio';
      var day = chosen('Date'), time = chosen('Time');
      if (sumWhen) sumWhen.textContent = day ? day + (time ? ', ' + time : ', choose a time') : 'Choose a day and time';
    }

    var original = button.textContent;
    var pcTimer = null;
    var distOpts = { lat: cfg.lat, lng: cfg.lng, radius: cfg.radius, postcodes: cfg.postcodes };
    var ukPostcode = /^[A-Z]{1,2}[0-9][A-Z0-9]?\s*[0-9][A-Z]{2}$/i;
    function showPc(res) {
      if (!pcResult) return;
      if (!res) { pcResult.textContent = ''; return; }
      if (res.checking) { pcResult.className = 'bbs-small bbs-muted'; pcResult.textContent = cfg.msgChecking; return; }
      if (res.invalid) { pcResult.className = 'bbs-small bbs-form-error'; pcResult.textContent = cfg.msgPostcodeBad; return; }
      pcResult.className = 'bbs-small ' + (res.ok ? 'bbs-form-success' : 'bbs-form-error');
      pcResult.textContent = res.ok ? cfg.msgYes : cfg.msgNo;
    }
    function checkPostcode() {
      if (!pcInput) return Promise.resolve(null);
      var v = pcInput.value.trim();
      if (!ukPostcode.test(v)) { showPc(null); return Promise.resolve(null); }
      showPc({ checking: true });
      return checkDistance(v, distOpts).then(function (res) { if (pcInput.value.trim() === v) showPc(res); return res; });
    }

    form.addEventListener('change', function (e) { if (e.target.name === 'attributes[Date]') refreshSlots(); update(); });
    if (pcInput) pcInput.addEventListener('input', function () { clearTimeout(pcTimer); pcTimer = setTimeout(checkPostcode, 400); update(); });
    refreshSlots();
    checkPostcode();
    update();

    function fail(msg, focusEl) {
      errorBox.textContent = msg; errorBox.hidden = false;
      if (focusEl && focusEl.focus) focusEl.focus();
      button.removeAttribute('aria-disabled'); update();
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (button.getAttribute('aria-disabled') === 'true') return;
      errorBox.hidden = true;
      var noteField = form.querySelector('[name="note"]');
      if (!cfg.booking) {
        button.setAttribute('aria-disabled', 'true');
        button.textContent = cfg.msgWorking;
        var clear = cfg.travelKey ? postJSON('/cart/change.js', { id: cfg.travelKey, quantity: 0 }) : Promise.resolve();
        clear.then(function () { return postJSON('/cart/update.js', { note: noteField ? noteField.value : '' }); })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function (err) { fail(err.message); });
        return;
      }
      var home = isHome();
      if (home && (!pcInput.value.trim() || !addrInput.value.trim())) return fail(cfg.msgPostcode, !pcInput.value.trim() ? pcInput : addrInput);
      if (home && !ukPostcode.test(pcInput.value.trim())) return fail(cfg.msgPostcodeBad, pcInput);
      if (!chosen('Date')) return fail(cfg.msgDate, form.querySelector('[name="attributes[Date]"]:not([disabled])'));
      if (!chosen('Time')) return fail(cfg.msgTime, form.querySelector('[name="attributes[Time]"]:not([disabled])'));

      button.setAttribute('aria-disabled', 'true');
      button.textContent = cfg.msgWorking;
      var pcCheck = home ? checkDistance(pcInput.value.trim(), distOpts) : Promise.resolve(null);
      pcCheck.then(function (res) {
        if (home && res && res.invalid) return fail(cfg.msgPostcodeBad, pcInput);
        if (home && res && res.ok === false) return fail(cfg.msgNo, pcInput);
        proceed(home);
      });
    });

    function proceed(home) {
      var deposit = payDeposit();

      var loc = form.querySelector('[name="attributes[Location]"]:checked').value;
      var patch = form.querySelector('[name="attributes[Patch test]"]');
      var noteEl = form.querySelector('[name="note"]');
      var attributes = {
        'Location': loc,
        'Postcode': home ? pcInput.value.trim().toUpperCase() : '',
        'Address': home ? addrInput.value.trim() : '',
        'Date': chosen('Date'),
        'Time': chosen('Time'),
        'Total time': cfg.duration || '',
        'Patch test': patch && patch.checked ? patch.value : '',
        'Payment': 'Paid in full online',
        'Balance due on the day': '',
        '_basket': ''
      };
      var total = cfg.subtotal + (home && cfg.travelVariant ? cfg.travelPrice : 0);

      if (deposit) {
        var balance = Math.max(total - cfg.depositPrice, 0);
        fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var keep = cart.items.filter(function (it) { return it.variant_id !== cfg.travelVariant && it.variant_id !== cfg.depositVariant; });
            var basket = keep.map(function (it) {
              var props = {};
              Object.keys(it.properties || {}).forEach(function (k) { if (it.properties[k] !== null && it.properties[k] !== '') props[k] = it.properties[k]; });
              return { id: it.variant_id, quantity: it.quantity, properties: props };
            });
            var names = keep.map(function (it) { return it.product_title + (it.quantity > 1 ? ' × ' + it.quantity : '') + ' (' + money(it.final_line_price) + ')'; });
            if (home && cfg.travelVariant) names.push('Travel (' + money(cfg.travelPrice) + ')');
            attributes['Payment'] = 'Pay in person: ' + money(cfg.depositPrice) + ' deposit paid online';
            attributes['Balance due on the day'] = money(balance) + ' (cash or card)';
            attributes['Treatments'] = names.join(', ');
            attributes['Booking total'] = money(total);
            attributes['_basket'] = JSON.stringify(basket);
            return postJSON('/cart/clear.js', {})
              .then(function () { return postJSON(routes.cart_add_url + '.js', { items: [{ id: cfg.depositVariant, quantity: 1, properties: { 'Treatments': names.join(', '), 'Booking total': money(total), 'Balance due on the day': money(balance) + ' (cash or card)' } }] }); })
              .then(function () { return postJSON('/cart/update.js', { attributes: attributes, note: noteEl ? noteEl.value : '' }); });
          })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function (err) { fail(err.message); });
        return;
      }
      attributes['Treatments'] = '';
      attributes['Booking total'] = '';

      var travelStep;
      if (home && cfg.travelVariant && !cfg.travelKey) {
        travelStep = postJSON(routes.cart_add_url + '.js', { items: [{ id: cfg.travelVariant, quantity: 1 }] });
      } else if (!home && cfg.travelKey) {
        travelStep = postJSON('/cart/change.js', { id: cfg.travelKey, quantity: 0 });
      } else {
        travelStep = Promise.resolve();
      }
      travelStep
        .then(function () { return postJSON('/cart/update.js', { attributes: attributes, note: noteEl ? noteEl.value : '' }); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (err) { fail(err.message); });
    }
  });

  /* Gift voucher product: amount pills update the card and button */
  document.querySelectorAll('[data-voucher]').forEach(function (form) {
    var idInput = form.querySelector('[name="id"]');
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-voucher-amount]')) {
        idInput.value = e.target.value;
        var label = e.target.getAttribute('data-label');
        document.querySelectorAll('[data-voucher-label]').forEach(function (el) { el.textContent = label; });
      }
      if (e.target.matches('[name="properties[To]"]')) {
        document.querySelectorAll('[data-voucher-to]').forEach(function (el) { el.textContent = e.target.value || 'Someone lovely'; });
      }
    });
    var to = form.querySelector('[name="properties[To]"]');
    if (to) to.addEventListener('input', function () {
      document.querySelectorAll('[data-voucher-to]').forEach(function (el) { el.textContent = to.value || 'Someone lovely'; });
    });
  });
})();
